import { APIComponentAttributes, APISurveyAttributes } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export type SetSurveyPaneDataPayload = {
  survey: APISurveyAttributes;
  component: APIComponentAttributes;
};

export const setSurveyPaneData = actionCreator<SetSurveyPaneDataPayload>(
  '[surveysPane] SET_SURVEY_PANE_DATA'
);
